var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    {
      staticClass: "login-form mb-3 pb-3 border-bottom",
      attrs: { errors: _vm.inputErrors },
      on: { submit: _vm.handleSubmit },
      model: {
        value: _vm.formValues,
        callback: function($$v) {
          _vm.formValues = $$v
        },
        expression: "formValues"
      }
    },
    [
      _c("h2", { staticClass: "form-title" }, [_vm._v("Galerie hinzufügen")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("FormulateInput", {
            staticClass: "col-12 col-md-6",
            attrs: {
              label: "Galeriename",
              name: "name",
              placeholder: "Galeriename",
              type: "text",
              validation: "required",
              "validation-name": "Galeriename"
            }
          }),
          _vm._v(" "),
          _c("FormulateInput", {
            staticClass: "col-12 col-md-6",
            attrs: {
              options: _vm.nationalServiceOptions,
              help:
                "Hinweis: wählen Sie hier ein Extra aus, wenn Sie wollen, dass diese Galerie bei einem Extra angezeigt wird.",
              label: "Nationales Extra",
              name: "national_service",
              placeholder: "Nationales Extra auswählen",
              type: "multiselect",
              validation: "optional",
              "validation-name": "Nationales Extra"
            }
          }),
          _vm._v(" "),
          _c("FormulateInput", {
            staticClass: "col-12",
            attrs: {
              help: "Wählen Sie ein PNG oder JPG zum Hochladen aus...",
              label: "Galeriebild hochladen",
              name: "image",
              type: "image",
              "add-label": "+ Bilder hinzufügen",
              validation: "required|mime:image/jpeg,image/png",
              "validation-messages": {
                mime: "Alle Bilder müssen die Endung PNG oder JPG haben."
              },
              "validation-name": "Bild",
              multiple: ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 d-flex flex-row justify-content-end" }, [
        _c("div", { staticClass: "btn-group mt-3", attrs: { role: "group" } }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-danger",
              attrs: { disabled: _vm.isSubmitting, type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancelNew")
                }
              }
            },
            [_vm._v("Abbrechen "), _c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-success",
              attrs: { disabled: _vm.isSubmitting, type: "submit" }
            },
            [
              _vm._v("Speichern "),
              !_vm.isSubmitting
                ? _c("i", { staticClass: "fas fa-plus" })
                : _vm._e(),
              _vm.isSubmitting
                ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
                : _vm._e()
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }